/**
 * Route-level Suspense fallback — احترافي، بسيط، مش مزعج
 * shimmer بدل animate-pulse (الـ pulse مزعج للعين)
 * 420ms fade-in ناعم + shimmer يتحرك 1.8s
 */
export function RouteFallback() {
  return (
    <div className="page-enter mx-auto max-w-7xl px-4 py-24 sm:px-6 lg:px-8">
      <div className="mx-auto h-6 w-32 rounded-full shimmer" />
      <div className="mx-auto mt-5 h-12 w-2/3 max-w-xl rounded-2xl shimmer" />
      <div className="mx-auto mt-4 h-4 w-1/2 rounded-full shimmer opacity-70" />
      <div className="mx-auto mt-9 h-14 max-w-2xl rounded-2xl shimmer opacity-60" />
      <ul className="mt-12 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {Array.from({ length: 6 }).map((_, i) => (
          <li
            key={i}
            className="h-48 rounded-2xl border border-border bg-card/40 shimmer"
            style={{ animationDelay: `${i * 70}ms` }}
          />
        ))}
      </ul>
    </div>
  )
}
